module.exports = __webpack_public_path__ + "img/20TOP-FALANGHINA-SML-COLORI-GARZA-COLORI-UNITI-LINO-STAMPE-LINO----RIC.SMARALDO2copia.3524f8a7.jpg";